import React from "react";
import cn from "classnames";

import SquareButton from "../SquareButton";

import ArrowRight from "../../Icons/ArrowRightShape";

import styles from "./SearchFilterButton.module.scss";

interface SearchFilterButtonProps  {
    disabled?: boolean;
    label: string;
    selections?: string;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => void;
}

/**
 * Search Filter Button
 */
const SearchFilterButton = (props: SearchFilterButtonProps) => {
    const {
        disabled,
        label,
        selections,
        onClick = () => { }
    } = props;

    const menuLblStyles = cn(styles.labelTitle, { [styles.showSelections]: selections });

    return (
        <SquareButton
            className={styles.button}
            color="white"
            onClick={onClick}
            disabled={disabled}
        >
            <span className={styles.labelContainer}>
                <span className={styles.labelBody}>
                    <span
                        data-testid="sf-menu-label"
                        className={menuLblStyles}
                    >
                        {label}
                    </span>
                    {(selections ? <span className={styles.labelSelections}>{selections}</span> : null)}
                </span>
                <ArrowRight className={styles.labelIcon} />
            </span>
        </SquareButton>
    );
};

export { SearchFilterButton as default };
export type { SearchFilterButtonProps };
